export default __webpack_public_path__ + "static/media/scheduletrans.53e5da61.svg";